<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      clipped
    >
      <v-list
        rounded
      >
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.link"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      app
      clipped-left
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <v-toolbar-title class="knoths-portfolio"
        v-if="!isTop"
      >
        Knoth's Portfolio
      </v-toolbar-title>
    </v-app-bar>

    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer app>
      <span>&copy; {{ year }} KnothSug.</span>
    </v-footer>
  </v-app>
</template>

<style>
footer {
  height: 10vh;
  max-height: 64px;
  min-height: 1em;
}
.knoths-portfolio {
  font-family: 'Playball', cursive;
  font-weight: 100;
}
.v-toolbar__title.knoths-portfolio {
  font-size: 1.6em;
}

</style>

<script>
  export default {
    props: {
      source: String,
    },

    data: function() {
      return {
        items: [
          { title: 'Top', link: '/', icon: 'mdi-home' },
          { title: 'Profile', link: '/profile', icon: 'mdi-account-circle' },
          { title: 'Twitter', link: '/twitter', icon: 'mdi-twitter' },
        ],
        drawer: null,
        year: new Date().getFullYear(),
      }
    },

    created: function () {
      this.$vuetify.theme.dark = true
    },

    computed: {
      isTop: function () {
        return this.$route.path == "/"
      }
    }
  }
</script>